<template>
    <div >
        <!--頁首-->
        <Header :header="header"></Header>
        <!--功能列表-->
        <Menulist :menulist="menulist"></Menulist>
        <!--功能列表_RWD-->
        <Menulist_RWD :menulist="menulist"></Menulist_RWD>
        <!--首頁內容-->
        <main class="main">
            <!--Banner輪播圖-->
            <banner :banner="banner"></banner>
            <!--最新消息-->
            <div class="hmnewsall">
                <div class="conbox">
                    <div class="homdisflex">
                        <div class="hom_left">
                            <!--最新消息標題&【更多】按鈕-->
                            <div class="hmtopic">
                                <div class="hmtptitle">
                                    News
                                </div>
                                <!--div class="hmsen">
                                    News
                                </div-->
                            </div>
                            <div class="morbtn" v-if="newsTypeSelect != 'ALL'">
                                <a :href="'/EN/News?PJ_ID='+newsTypeSelect+'&modal='+newsTypeModalSelect">
                                    More
                                </a>
                            </div>
                        </div>
                        <div class="hom_right">
                            <!--最新消息類別列表-->
                            <div class="hom_newstab">
                                 <!--全部公告(需移除更多按鈕)-->
                                <div class="hm_ntbbx">
                                    <a href="#" :class="(newsTypeSelect == 'ALL')?'tbact':''" @click.prevent="newsTypeSelect ='ALL' ;newsTypeModalSelect=''; getNews(-1);"  >All</a>
                                </div>
                                <!--各項類別按鈕-->
                                <div class="hm_ntbbx" v-for="item in newsTypeList" v-bind:key="item.index">
                                    <a href="#" :class="(item.PJ_ID == newsTypeSelect)?'tbact':''" @click.prevent="newsTypeSelect = item.PJ_ID ;newsTypeModalSelect=item.modal; getNews(item.typeId);"  >{{item.title}}</a>
                                </div>
                            </div> 
                            <!--最新消息列表-->
                            <div class="hmnewlisall">
                                <!--最新消息-最新5筆資料-->
                                <div class="hmnewbox" v-for="item in newsList">
                                    <a :href="item.url">
                                        <div class="hmnewdat">
                                            <!--輸入上架日期&標籤-->
                                            <div class="hmdtex">
                                                {{ item.startDate }}
                                            </div>
                                            <div class="hmdtag tag_org" v-if="item.use_org">
                                                important
                                            </div>
                                            <div class="hmdtag tag_pink" v-if="item.use_red">
                                                hot
                                            </div>
                                        </div>
                                        <div class="hmnewword">
                                            <!--標題文字-->
                                            {{ item.title }}
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <!--RWD手機版本使用-->
                            <div class="morbtn RWD_more">
                                <a :href="'/EN/News?PJ_ID='+newsTypeSelect+'&modal='+newsTypeModalSelect">
                                    More
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--活動相簿-->
            <div class="homphoto">
                <div class="conbox">
                    <div class="homdisflex">
                        <div class="hom_left">
                            <!--活動相簿標題&【更多】按鈕-->
                            <div class="hmtopic">
                                <div class="hmtptitle">
                                    Album
                                </div>
                                <!--div class="hmsen">
                                    Album
                                </div-->
                            </div>
                            <div class="morbtn">
                                <a href="/EN/News?PJ_ID=PJ20250304&modal=2">
                                    More
                                </a>
                            </div>
                        </div>
                        <div class="hom_right">
                            <!--活動相簿列表-->
                            <div class="hmphoall">
                                <!-- TODO 抓取活動相簿-最新3筆資料-->
                                <div class="hmphobox" v-for="item in albumList">
                                    <a :href="item.url">
                                        <div class="hmphobox_pc">
                                            <!--預設圖片-->
                                            <img :src="item.pic" onerror="this.src='/images/default.jpg'"></img>
                                        </div>
                                        <div class="hmphobox_title">
                                            <!--標題文字-->
                                            {{ item.title}}
                                        </div>
                                        <div class="hmphobox_date">
                                            <!--上架時間-->
                                            {{item.startDate}}
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <!--RWD手機版本使用-->
                            <div class="morbtn">
                                <a href="/EN/News?PJ_ID=PJ20250304&modal=2">
                                    More
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--生傳影音-->
            <div class="homvideo">
                <div class="conbox">
                    <div class="homdisflex">
                        <div class="hom_left">
                            <!--生傳影音標題&【更多】按鈕-->
                            <div class="hmtopic">
                                <div class="hmtptitle">
                                    Video
                                </div>
                                <!--div class="hmsen">
                                    Video
                                </div-->
                            </div>
                            <div class="morbtn">
                                <a href="EN/News?PJ_ID=PJ20250307&modal=2">
                                    More
                                </a>
                            </div>
                        </div>
                        <div class="hom_right">
                            <!--生傳影音列表-->
                            <div class="hmphoall">
                                <!-- TODO 抓取生傳影音-最新3筆資料-->
                                <div class="hmphobox" v-for="item in videoList">
                                    <a href="#" @click="showViewerVideo(item)">
                                        <div class="hmphobox_pc">
                                            <!--預覽圖片-->
                                            <!-- TODO 動態YT預覽圖片-->
                                            <img :src="'https://img.youtube.com/vi/'+item.videoimg+'/sddefault.jpg'" onerror="this.src='/images/default.jpg'"></img>
                                            <div class="vidoplay">
                                                <img src="/images/videoplay.svg"></img>
                                            </div>
                                        </div>
                                        <div class="hmphobox_title">
                                            <!--標題文字-->
                                            {{ item.title }}
                                        </div>
                                        <div class="hmphobox_date">
                                            <!--上架時間-->
                                            {{ item.startDate }}
                                        </div>
                                    </a>
                                </div>
                                
                                <!--影片播放器-->
                                <VideoModal :viewer="viewer"></VideoModal>
                            </div>
                            <div class="morbtn RWD_more">
                                <a href="EN/News?PJ_ID=PJ20250307&modal=2">
                                    More
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--友站連結-->
            <div class="soclink">
                <div class="conbox soctpborder">
                    <div class="homdisflex">
                        <div class="hom_left">
                            <div class="hm_fbtitle">
                                <!--標題文字-->
                                Links
                            </div>
                        </div>
                        <div class="home_right">
                            <div class="hm_fbcont">
                                <!--友站連結列表-->
                                <!--TODO 動態抓取友站連結-最新3筆資料-->
                                <!--臺大生傳系學會-->
                                <div class="hm_fbcbox">
                                    <a href="https://www.facebook.com/NTUBICDSA/" target="_blank">
                                        <div class="hmfbcn_pc">
                                            <!--友站圖片-->
                                            <img src="/images/solink01.png"/>
                                        </div>
                                        <div class="hmfbcn_txt">
                                            <!--友站標題-->
                                            台大生傳系學會
                                        </div>
                                    </a>
                                </div>
                                <!--國立臺灣大學農推暨生傳系友會-->
                                <div class="hm_fbcbox">
                                    <a href="https://www.facebook.com/NTU1960AgriculturalExtensionAndBICDAlumni#" target="_blank">
                                        <div class="hmfbcn_pc">
                                            <!--友站圖片-->
                                            <img src="/images/solink02.png"/>
                                        </div>
                                        <div class="hmfbcn_txt">
                                            <!--友站標題-->
                                            國立臺灣大學
                                            <br>
                                            農推暨生傳系友會
                                        </div>
                                    </a>
                                </div>
                                <!--臺大生傳系碩士在職專班-->
                                <div class="hm_fbcbox">
                                    <a href="https://www.facebook.com/BICDEMBA?modal=admin_todo_tour#" target="_blank">
                                        <div class="hmfbcn_pc">
                                            <!--友站圖片-->
                                            <img src="/images/solink03.png"/>
                                        </div>
                                        <div class="hmfbcn_txt">
                                            <!--友站標題-->
                                            臺大生傳系
                                            <br>
                                            碩士在職專班
                                        </div>
                                    </a>
                                </div>
                                <!--國立臺灣大學生物產業傳播暨發展學系臉書-->
                                <div class="hm_fbcbox">
                                    <a href="https://www.facebook.com/ntubioagribicd#" target="_blank">
                                        <div class="hmfbcn_pc">
                                            <!--友站圖片-->
                                            <img src="/images/solink02.png"/>
                                        </div>
                                        <div class="hmfbcn_txt">
                                            <!--友站標題-->
                                            國立臺灣大學
                                            <br>
                                            生物產業傳播暨發展學系臉書
                                        </div>
                                    </a>
                                </div>
                                 <!--國立臺灣大學生物產業傳播暨發展學系IG-->
                                <div class="hm_fbcbox">
                                    <a href="https://www.instagram.com/ntubicd/" target="_blank">
                                        <div class="hmfbcn_pc">
                                            <!--友站圖片-->
                                            <img src="/images/solink02.png"/>
                                        </div>
                                        <div class="hmfbcn_txt">
                                            <!--友站標題-->
                                            國立臺灣大學
                                            <br>
                                            生物產業傳播暨發展學系IG
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <!--頁尾-->
        <Footer :footer="footer"></Footer>
        <!--goto按鈕-->
        <GoTop></GoTop>
    </div>
</template>
<script>
import Header from '../../components/default_en/NavBar/Header.vue';
import Menulist from '../../components/default_en/NavBar/Menulist.vue';
import Menulist_RWD from '../../components/default_en/NavBar/Menulist_RWD.vue';
import Footer from '../../components/default_en/NavBar/Footer.vue';
import GoTop from '../../components/default_en/Tool/GoTop.vue';
import VideoModal from '../../components/default_en/Tool/VideoModal.vue';
import Banner from '../../components/default_en/Tool/Banner.vue';
export default{
    components:{
        Header,
        Menulist,
        Menulist_RWD,
        Banner,
        Footer,
        GoTop,
        VideoModal,
    },
    data() {
        return {
            //頁首
            header:{
                text1:"Department of Bio-Industry Communication and Development",
                text2:"",
            },
            //功能列表 &功能列表_RWD
            menulist:{
                place:""
            },
            //頁尾
            footer:{
                index :true,
            },
            //Banner輪播圖
            banner:{
                total:4,
            },
            //頁碼
            pagination:{
                page: 1,//目前第幾筆(固定頁數)
                newsPage: 10,//最新消息顯示數量
                academicPage: 3,//學術活動顯示數量
                announcementsPage: 3,//系所公告顯示數量
                albumPage: 3,//活動相簿顯示數量
                videoPage: 3,//最新消息顯示數量
            },
            //語言
            langurage:2,
            //已選取的最新消息類別
            newsTypeSelect:"",
            newsTypeModalSelect:"",
            //
            slides: [],
            // 類別列表區
            //最新消息類別
            newsTypeList:[],
            //最新消息
            newsList:[],
            //學術活動
            academicList:[],
            //系所公告
            announcementsList:[],
            //活動相簿
            albumList:[],
            //生傳影音
            videoList:[],
            //播放器參數值
            viewer: {},
            //特殊類別不顯示清單(排除活動花絮、生傳影片)
            newstypePassList:["PJ20250304","PJ20250307"]
        };
    },
    computed:{

    },
    mounted(){
        //初始化
        this.init();
    },
    methods:{
        //初始化
        async init(){
            await Promise.all([
                //取得最新消息類別
                this.getNewsType(),
            //取得最新消息5筆資料
                await this.getNews(-1),
            //取得活動相簿3筆資料
                await this.getAlbum(),
            //生傳影音3筆資料
                await this.getVideo(),
            ]);
            
        },
        //取得最新消息類別
        async getNewsType(){
            try{
                //POST
                let jsonReq ={
                    TYPE: "GetHeader_front",
                    latestnews_type_SELECT:{
                        langurage :this.langurage,
                    },
                }
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API
                let res= await this.userRequest.post("bicd/LatestNewsType",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    //清空類別清單
                    this.newsTypeList = [];
                    let jsonData = JSON.parse(json.Data);
                    jsonData.forEach((x,index) => {
                        //排除名單中的類別
                        if(!this.newstypePassList.includes(x.PJ_ID)){
                            //初始化時抓取第一筆資料名稱
                            if(this.newsTypeList.length == 0){
                                this.newsTypeSelect = 'ALL';
                                this.newsTypeModalSelect = -1;
                            }
                            let data = {
                                index: index,
                                title: x.etitle,
                                PJ_ID: x.PJ_ID,
                                modal: x.modal,
                                typeId:x.TypeId,
                }
                            this.newsTypeList.push(data);
            }
                        });
                    }

            }catch(err){
                console.log("ErrFunction: getNewsType/n "+err);
            }
        },
        //取得最新消息5筆資料
        async getNews(typeId){
            try{
                //POST 參數
                let jsonReq ={
                    TYPE:"HOME_LIST",
                    latestnews_SELECT:{
                        langurage :this.langurage,
                        typeId:typeId == -1? null : typeId,
                        pageIndex:this.pagination.page,
                        pageSize: this.pagination.newsPage,
                    },
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res =await this.userRequest.post("bicd/LatestNews",jsonReq);
                //讀取資料
                let json= JSON.parse(res.data);
                if(json.Status){
                    this.newsList= [];
                    let jsonData = JSON.parse(json.Data);
                    if(jsonData.outData.length> 0){
                        jsonData.outData.forEach((x) => {
                            let data = {
                                title: x.title,
                                url: "News?PJ_ID="+x.PJ_ID+"&modal="+x.typeModal+"&id="+x.id,
                                startDate:x.startDate.split('T')[0],
                                use_org: (x.markUp && x.markUp.includes('1'))?true:false,
                                use_red: (x.markUp && x.markUp.includes('2'))?true:false,
                            };
                            this.newsList.push(data);
                        });
                    }
                }
            }catch(err){
                console.log("ErrFunction: getNews/n "+err);
            }

        },
        //取得活動相簿3筆資料
        async getAlbum(){
            try{
                //POST 參數
                let jsonReq ={
                    TYPE:"HOME_LIST",
                    latestnews_SELECT:{
                        langurage :this.langurage,
                        typeId: 4,
                        pageIndex:this.pagination.page,
                        pageSize: this.pagination.albumPage,
                    },
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res =await this.userRequest.post("bicd/LatestNews",jsonReq);
                //讀取資料
                let json= JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    if(jsonData.outData.length> 0){
                        jsonData.outData.forEach((x) => {
                            let data = {
                                title: x.title,
                                url: "News?PJ_ID="+x.PJ_ID+"&modal="+x.typeModal+"&id="+x.id,
                                startDate:x.startDate.split('T')[0],
                                pic: '/filestore'+x.filePath,
                            };
                            this.albumList.push(data);
                        });
                    }
                }
            }catch(err){
                console.log("ErrFunction: getAlbum/n "+err);
            }
        },
        //生傳影音(榮譽事項)3筆資料
        async getVideo(){
            try{
                //POST 參數
                let jsonReq ={
                    TYPE:"HOME_LIST",
                    latestnews_SELECT:{
                        langurage :this.langurage,
                        typeId: 7,
                        pageIndex:this.pagination.page,
                        pageSize: this.pagination.videoPage,
                    },
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res =await this.userRequest.post("bicd/LatestNews",jsonReq);
                //讀取資料
                let json= JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    if(jsonData.outData.length> 0){
                        jsonData.outData.forEach((x) => {
                            let data = {
                                title: x.title,
                                url: x.url,
                                startDate:x.startDate.split('T')[0],
                                videoimg: x.youtubeCode,
                            };
                            this.videoList.push(data);
                        });
                    }
                }
            }catch(err){
                console.log("ErrFunction: getVideo/n "+err);
            }
        },
        showViewerVideo(data) {
            this.viewer = {
                confirm: true,
                title: data.title,
                url: data.url,
                linkMethod: data.linkMethod,
            };
        },
    }
}
</script>